export const en = {
    "after-publish": "After publishing, dialogs become available to users.",
    "auto": "Auto",
    "auto-apps": "Auto apps",
    "create-dialog": "Create dialog",
    "drafts": "Drafts",
    "drafts-description": "Drafts are dialogs that have not yet been published and are not available to users. After the draft has been moderated, you can publish it.",
    "app-drafts-description": "Drafts are applications that have not yet been published and are not available to users. After the draft has been moderated, you can publish it.",
    "events": "Events",
    "limit-exceeded": "The limit on the number of registered skills has been exceeded. Read more in {{link}}",
    "limit-exceeded__doc": "documentation",
    "need-attention": "Needs attention",
    "published": "Published",
    "smart-screen": "DuoMax",
    "smart-screen-apps": "DuoMax apps",
    "tv": "YaOS TV",
    "tv-apps": "TV apps",
    "table-comment": "Comment",
    "table-dialog": "Dialog",
    "table-event": "Event",
    "table-time": "Time",
    "alice-skills": "Alice skills",
    "alice-agents": "Agents",
    "applications": "Applications",
    "default-dialog-name": "New dialog",
    "all-available-apps": "All available",
    "my-apps": "My apps",
    "show-only-published": "Only published apps",
    "search-by-yaos-apps": "Search YaOS apps",
    "title": "Title",
} as const;
export const ru = {
    "after-publish": "После публикации диалоги становятся доступны пользователям.",
    "auto": "Авто",
    "auto-apps": "Авто приложения",
    "create-dialog": "Создать диалог",
    "drafts": "Черновики",
    "drafts-description": "Черновики — это диалоги, которые еще не опубликованы и недоступны пользователям. После того, как черновик пройдет модерацию, вы сможете его опубликовать.",
    "app-drafts-description": "Черновики — это приложения, которые еще не опубликованы и недоступны пользователям. После того, как черновик пройдет модерацию, вы сможете его опубликовать.",
    "events": "События",
    "limit-exceeded": "Превышено ограничение на количество зарегистрированных навыков. Подробнее в {link}",
    "limit-exceeded__doc": "документации",
    "need-attention": "Требуют внимания",
    "published": "Опубликованные",
    "smart-screen": "Дуо Макс",
    "smart-screen-apps": "Дуо Макс приложения",
    "tv": "YaOS TV",
    "tv-apps": "ТВ приложения",
    "table-comment": "Комментарий",
    "table-dialog": "Диалог",
    "table-event": "Событие",
    "table-time": "Время",
    "alice-skills": "Навыки в Алисе",
    "alice-agents": "Агенты",
    "applications": "Приложения",
    "default-dialog-name": "Новый диалог",
    "all-available-apps": "Все доступные",
    "my-apps": "Мои",
    "show-only-published": "Только опубликованные приложения",
    "search-by-yaos-apps": "Поиск по приложениям YaOS",
    "title": "Название",
} as const;
